import gidUtil from 'core/application/util/GIDUtil';

'use strict';

/**
 * Custom angularjs directives.
 *
 * @class Filters
 * @module Core
 * @static
 */
let filterDefinitions = {
    /**
     * Formats unit to millions/thousands.
     *
     * @method formatBytes
     * @param {Number} input Input number
     * @return {String}
     */
    formatBytes: ['util', function (util) {
        return function (input) {
            return util.formatBytes(input);
        };
    }],

    /**
     * Paging. Limits results in ng-repeat. Use as last filter on list
     *
     * @method pagerFilter
     * @param {Array} input array of elements
     * @param {Object} pager object representing page
     * @return {String}
     */
    pagerFilter: ()=> {
        return (input, pager) => {
            if (pager === undefined) {
                return input;
            }
            if (typeof pager.getFrom != 'function' || typeof pager.getTo != 'function') {
                return [];
            }
            if (pager.totalItems != input.length)
                pager.page = 1;
            pager.totalItems = input.length;
            return input.slice(pager.getFrom() - 1, pager.getTo());
        };
    },

    gidToPersonId: function () {
        return gidUtil.personCodeFromFgid;
    },

    gidToCustomerId: function () {
        return gidUtil.customerCodeFromJgid;
    },

    gidToId: function () {
        return gidUtil.codeFromGid;
    },

    capitalize: function () {
        return function (input) {
            if (!input) {
                return '';
            }
            var tokens = _.map(input.split(' '), function (str) {
                str = str.toLowerCase();
                var subtokens = _.map(str.split('-'), function (str) {
                    return str.charAt(0).toUpperCase() + str.slice(1);
                });
                str = subtokens.join('-');
                return str.charAt(0).toUpperCase() + str.slice(1);
            });
            return tokens.join(' ');
        };
    },

    orderByLocale: function () {
        return function (input, name) {
            if (!input || !name)
                return;
            return input.sort((a, b) => a[name].localeCompare(b[name]));
        };
    }
};

export default filterDefinitions;


// WEBPACK FOOTER //
// ./src/main/ui/core/filters/FilterDefinitions.ts